import React from 'react';
import { shape, arrayOf } from 'prop-types';
import Item from './Item';

const SubItems = (props) => {
  const { items, style, className } = props;
  return (
    <ul style={style} className={`collapse ${className}`}>
      {
        items && items.map(item => <Item key={item.id} item={item} />)
      }
    </ul>
  );
};

SubItems.propTypes = {
  items: arrayOf(shape({})).isRequired,
  style: shape({}),
};

SubItems.defaultProps = {
  style: {},
};

export default SubItems;
